import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-182" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-183" data-mp="1t8niy08x17ou">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-184" data-mp="1oac9hqmj8z75">
          Liczby, które mówią same za siebie
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-185" data-mp="1jeom9grm2g4a">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-186" data-mp="19lz8gf8l8q5s" data-mpi={index}>
              <dt className="sr-only" data-id="element-187" data-mp="10m2sr346f1mv">{stat.label}</dt>
              <dd data-id="element-188" data-mp="10nnnotuekml9">
                <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-189" data-mp="10jzqnkpr1i1s">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-190" data-mp="qoob506io6sz">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}